export default {
    login: {
        title: 'Accedi al tuo account',
        subtitle: 'Inserisci le tue credenziali per accedere al pannello amministrativo',
        emailLabel: 'Email',
        emailPlaceholder: 'nome@azienda.com',
        passwordLabel: 'Password',
        passwordPlaceholder: '••••••••',
        forgotPassword: 'Password dimenticata?',
        submitButton: 'Accedi',
        noAccount: 'Non hai un account?',
        contactAdmin: 'Contatta l\'amministratore',
        credentialsTitle: 'Credenziali Demo',
        errorInvalidCredentials: 'Credenziali non valide',
        errorLogin: 'Errore durante il login',
    },
    resetPassword: {
        title: 'Reimposta password',
        subtitle: 'Inserisci la tua email e ti invieremo un link per reimpostare la password',
        emailLabel: 'Email',
        emailPlaceholder: 'nome@azienda.com',
        submitButton: 'Invia link di reset',
        backToLogin: 'Torna al login',
        successTitle: 'Email inviata!',
        successMessage: 'Ti abbiamo inviato un link per reimpostare la password all\'indirizzo',
        successInstructions: 'Controlla la tua casella di posta.',
        backToLoginButton: 'Torna al Login',
        sendAnotherEmail: 'Invia un\'altra email',
    },
};

